import Vue from 'vue'
import Router from 'vue-router'
import { eachRouter } from '../../common/js/Util'

Vue.use(Router)
const Meta = titles => ({ title: titles })

const routes = [
  {
    path: '/',
    redirect: '/index'
  }, 
  {
    path: '/index',
    name: 'index',
    component: () => import('./views/home/index.vue'),
    meta: Meta('好友送福袋')
  },
  {
    path: '/detail',
    name: 'detail',
    component: () => import('./views/detail/index.vue'),
    meta: Meta('测试')
  }
]

// 路由正则处理，用于微信防封
eachRouter(routes)

export default new Router({
  mode: 'history',
  base: '/yunjiactivity/viprecall',
  routes: routes
})
